import { useAuthContext } from "../../context/AuthContext";
import useDownlaodPdf from "../useDownlaodPdf";
import { DOWNLOAD_REPORT_PDF } from "../../apis/configuration";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { analytics, triggerLogEvent } from "../../config/firebase";

const toDateString = (date) =>
  dayjs(date?.toDate ? date.toDate() : date).format("YYYY-MM-DD");

const useReportExport = (reportType) => {
  const { user, business } = useAuthContext();
  const navigate = useNavigate();
  const { onDownload, downloadLoading } = useDownlaodPdf(user, DOWNLOAD_REPORT_PDF);

  const handleExport = (startDate, endDate) => {
    if (!startDate || !endDate) return;
    triggerLogEvent(analytics, `report_${reportType}_downloaded`, {
      start_date: toDateString(startDate),
      end_date: toDateString(endDate),
    });
    onDownload(
      {
        report_type: reportType,
        business_id: business?.id,
        start_date: toDateString(startDate),
        end_date: toDateString(endDate),
        pdf: true,
        name: `${reportType}_report.pdf`,
      },
      () => {},
      navigate,
    );
  };

  return { handleExport, exportLoading: downloadLoading };
};

export default useReportExport;
